import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import DetaljPageHeader from "../../Common/Detalj/DetaljPageHeader";
import Map from "../../Common/Maps/MapView";
import BilderAndMiljokontrollsobservasjonsbilderContainer from "../../Common/Miljogebyr/Detalj/BilderAndMiljokontrollsobservasjonsbilderContainer";
import BilderContainer from "../../Common/Miljogebyr/Detalj/BilderContainer";
import Ettersendelser from "../../Common/Miljogebyr/Detalj/Ettersendelser";
import KlageinformasjonContainer from "../../Common/Miljogebyr/Detalj/KlageinformasjonContainer";
import MiljogebyrGridOgKommentarContainer from "../../Common/Miljogebyr/Detalj/MiljogebyrGridOgKommentarContainer";
import MiljokontrollContainer from "../../Common/Miljogebyr/Detalj/MiljokontrollContainer";
import MiljokontrollKommentarerContainer from "../../Common/Miljogebyr/Detalj/MiljokontrollKommentarerContainer";
import MottakerAvMiljogebyrContainer from "../../Common/Miljogebyr/Detalj/MottakerAvMiljogebyrContainer";
import NyeEttersendelser from "../../Common/Miljogebyr/Detalj/NyeEttersendelser";
import TilbakemeldingerFraBybetjenterContainer from "../../Common/Miljogebyr/Detalj/TilbakemeldingerFraBybetjenterContainer";
import Spinner from "../../Common/Spinner";
import BilderButtonsContainer from "./BilderButtonsContainer";
import ButtonsContainer from "./ButtonsContainer";
import FolgebrevContainer from "./FolgebrevContainer";
import HistorikkOgKommentarerContainer from "./HistorikkOgKommentarerContainer";
import MakuleringsarsakContainer from "./MakuleringsarsakContainer";
import SystemloggContainer from "./SystemloggContainer";

import { getBybetjenter } from "../../../actions/bybetjenterActions";
import { getMiljogebyr } from "../../../actions/miljogebyrerActions";
import { getMiljogebyrEttersendelser } from "../../../actions/miljogebyrEttersendelserActions";

import { bypatruljen } from "../../../constants/roles";
import { authorized } from "../../../utils/authorizationUtils";

import { text } from "../../../constants/text";
import * as title from "../../../constants/titles";

import KlagebehandlingInformasjonContainer from "../../../components/Common/Miljogebyr/Detalj/KlagebehandlingInformasjonContainer";
import "./MiljogebyrDetaljerPage.css";

export default function MiljogebyrDetaljPage() {
  const dispatch = useDispatch();
  const { id: miljogebyrId } = useParams();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const [isLoadingMiljokontrollBilder, setIsLoadingMiljokontrollBilder] =
    useState(false);

  useEffect(() => {
    document.title = title.miljogebyrDetalj();
    window.scrollTo(0, 0);
    dispatch(getMiljogebyr(miljogebyrId))
      .then((result) => {
        document.title = title.miljogebyrDetalj(result.ileggelsesnummer);
      })
      .catch(() => (document.title = title.miljogebyrDetalj()));
    dispatch(getMiljogebyrEttersendelser(miljogebyrId));
    dispatch(getBybetjenter({ onlyActive: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (miljogebyr && miljogebyr.id === miljogebyrId) {
    return (
      <div className="miljogebyr-content-wrapper">
        <DetaljPageHeader
          pageName={text.miljoGebyr.pageName}
          pageId={String(miljogebyr.ileggelsesnummer)}
          isMakulert={miljogebyr.isMakulert}
        />
        <Tabs
          defaultActiveKey={1}
          id="tabs-miljogebyr-kart"
          className="detailjTab"
          mountOnEnter
        >
          <Tab eventKey={1} title="Miljøgebyr">
            <div className="miljogebyr-tab-content-wrapper">
              <ButtonsContainer miljogebyrId={miljogebyrId} />
              <MiljogebyrGridOgKommentarContainer miljogebyr={miljogebyr} />
              <TilbakemeldingerFraBybetjenterContainer
                miljogebyrId={miljogebyrId}
              />
              <MottakerAvMiljogebyrContainer miljogebyrId={miljogebyrId} />
              {authorized([
                bypatruljen.saksbehandleradmin,
                bypatruljen.saksbehandler,
              ]) && <FolgebrevContainer miljogebyrId={miljogebyrId} />}
              {miljogebyr && miljogebyr.miljoKontrollId && (
                <>
                  <MiljokontrollContainer
                    miljoKontrollId={miljogebyr.miljoKontrollId}
                    setIsLoadingMiljokontrollBilder={
                      setIsLoadingMiljokontrollBilder
                    }
                  />
                  <MiljokontrollKommentarerContainer
                    miljogebyrId={miljogebyrId}
                  />
                  <BilderAndMiljokontrollsobservasjonsbilderContainer
                    miljogebyrId={miljogebyrId}
                    BilderButtonsContainer={BilderButtonsContainer}
                    checkboxText="Til ettersendelse"
                    isLoadingMiljokontrollBilder={isLoadingMiljokontrollBilder}
                  />
                </>
              )}
              {miljogebyr && !miljogebyr.miljoKontrollId && (
                <BilderContainer
                  miljogebyrId={miljogebyrId}
                  BilderButtonsContainer={BilderButtonsContainer}
                  checkbox
                />
              )}
              <Ettersendelser />
              <NyeEttersendelser />
              <KlageinformasjonContainer miljogebyrId={miljogebyrId} />
              <KlagebehandlingInformasjonContainer
                miljogebyrId={miljogebyrId}
              />
              <SystemloggContainer miljogebyrId={miljogebyrId} />
              <MakuleringsarsakContainer />
              <HistorikkOgKommentarerContainer miljogebyrId={miljogebyrId} />
            </div>
          </Tab>
          <Tab eventKey={2} title="Kart">
            <div className="miljogebyr-tab-content-wrapper">
              <Map lat={miljogebyr.latitude} lng={miljogebyr.longitude} />
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
  return (
    <div>
      <Spinner isLoading />
    </div>
  );
}
